(function () {
  var config = window.CBDMD_TN_GEO;
  if (!config || !config.enabled) return;

  var DEFAULT_GEO_URL = 'https://ipapi.co/json/';
  var geoApiUrl = (config.geoApiUrl && String(config.geoApiUrl).trim()) || DEFAULT_GEO_URL;
  var cacheMin = parseInt(config.geoCacheMinutes, 10);
  if (isNaN(cacheMin) || cacheMin < 0) {
    cacheMin = 1440;
  }
  var STORAGE_TTL_MS = cacheMin * 60 * 1000;
  var useGeoCache = STORAGE_TTL_MS > 0;
  var GEO_STORAGE_KEY = 'cbdmd_tn_geo_v1';
  var POPUP_STORAGE_KEY = 'cbdmd_tn_popup_shown_v1';
  var STATE_CODE = String(config.stateCode || 'TN').toUpperCase();

  var modal = document.getElementById('TennesseeStateBlocker');
  if (!modal) return;

  function showModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tennessee-state-blocker-open');
    document.body.classList.add('tennessee-state-blocker-open');
  }

  function hideModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tennessee-state-blocker-open');
    document.body.classList.remove('tennessee-state-blocker-open');
  }

  function isTennessee(regionCode, countryCode) {
    if (String(countryCode || '').toUpperCase() !== 'US') return false;
    return String(regionCode || '').toUpperCase() === STATE_CODE;
  }

  function isWithinTtl(ts) {
    return (Date.now() - ts) <= STORAGE_TTL_MS;
  }

  function getCachedGeo() {
    if (!useGeoCache) {
      return null;
    }
    try {
      var raw = localStorage.getItem(GEO_STORAGE_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.data) return null;

      if (parsed.apiUrl && parsed.apiUrl !== geoApiUrl) {
        return null;
      }

      if (!isWithinTtl(parsed.ts)) {
        localStorage.removeItem(GEO_STORAGE_KEY);
        return null;
      }

      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function setCachedGeo(data) {
    if (!useGeoCache) {
      return;
    }
    try {
      localStorage.setItem(GEO_STORAGE_KEY, JSON.stringify({
        ts: Date.now(),
        data: data,
        apiUrl: geoApiUrl
      }));
    } catch (e) {}
  }

  function hasSeenPopupRecently() {
    if (!useGeoCache) {
      return false;
    }
    try {
      var raw = localStorage.getItem(POPUP_STORAGE_KEY);
      if (!raw) return false;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts) return false;

      if (!isWithinTtl(parsed.ts)) {
        localStorage.removeItem(POPUP_STORAGE_KEY);
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  function markPopupShown() {
    if (!useGeoCache) {
      return;
    }
    try {
      localStorage.setItem(POPUP_STORAGE_KEY, JSON.stringify({
        ts: Date.now()
      }));
    } catch (e) {}
  }

  async function fetchGeo() {
    var cached = getCachedGeo();
    if (cached) return cached;

    var response = await fetch(geoApiUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Geo lookup failed with status ' + response.status);
    }

    var data = await response.json();
    setCachedGeo(data);
    return data;
  }

  function bindModalClose() {
    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-tn-close]')) {
        hideModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        hideModal();
      }
    });
  }

  function maybeShowNotice() {
    if (hasSeenPopupRecently()) {
      return;
    }

    showModal();
    markPopupShown();
  }

  async function init() {
    bindModalClose();

    try {
      var geo = await fetchGeo();
      var countryCode = geo && (geo.country_code || geo.country);
      var regionCode = geo && (geo.region_code || geo.region);

      if (isTennessee(regionCode, countryCode)) {
        maybeShowNotice();
      }
    } catch (err) {
      console.warn('[TennesseeStateBlocker]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
